import { zodSchemes } from '@approvalmax/utils';
import { CountryIsoCode } from 'shared/data/walletsKyc/v1';
import { z } from 'zod';

import { AdoptedRole } from './RoleStep.constants';
import { messages } from './RoleStep.messages';

export const baseSchema = z.object({
    ownershipPercentage: z.number().nullish(),
    adoptedRoles: z.nativeEnum(AdoptedRole, { required_error: messages.requiredField }),
    firstName: zodSchemes.required.textField.string(),
    middleName: z.string().optional(),
    lastName: zodSchemes.required.textField.string(),
    email: z.string({ required_error: messages.requiredField }).trim().email(),
    verifyNeeded: z.boolean(),
    isWalletOwner: z.boolean(),
});

export const personSchema = z.discriminatedUnion('verifyNeeded', [
    baseSchema.extend({
        verifyNeeded: z.literal(true),
        // this for a typing sake only. the field will be undefined
        homeCountry: z.nativeEnum(CountryIsoCode).optional(),
    }),
    baseSchema.extend({
        verifyNeeded: z.literal(false),
        homeCountry: zodSchemes.required.select.enum(CountryIsoCode),
    }),
]);

export const schema = z.object({
    person: personSchema.superRefine((values, ctx) => {
        if (values.adoptedRoles?.includes('owner') && typeof values.ownershipPercentage !== 'number') {
            ctx.addIssue({
                path: ['ownershipPercentage'],
                message: messages.requiredField,
                code: z.ZodIssueCode.custom,
            });
        }
    }),
});
